import React, { useEffect, useState } from "react";
import axios from "axios";
import "./Report.css";
import GrievanceHeader from "../GrievanceHeader";

export default function VzyReport() {
  const [reportRows, setReportRows] = useState([]);
  const [loading, setLoading] = useState(true);

  // Set the base URL globally
  const apiBaseURL =
    process.env.REACT_APP_API_URL || `${window.location.origin}`;

  const fetchReportData = async () => {
    try {
      const response = await axios.get(
          `${apiBaseURL}/api/WatchoGrievance/GetVZYGrievanceReport`
      );

      const data = response.data?.result || [];
      setReportRows(data);
    } catch (error) {
      console.error("Error fetching report data:", error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    // const fetchReportData = async () => {
    //   try {
    //     const response = await axios.get(
    //       `${apiBaseURL}/api/WatchoGrievance/GetGrievanceReport`
    //     );
    //     const data = response.data?.result || [];
    //     setReportRows(data);

    //     setReportRows(data);
    //   } catch (error) {
    //     console.error("Error fetching report data:", error);
    //   } finally {
    //     setLoading(false);
    //   }
    // };

    fetchReportData();
  }, []);

  if (loading) return <div>Loading...</div>;
  if (!reportRows.length) return <div>No report data available</div>;

  return (
    <>
      {/* <GrievanceHeader /> */}
      <div id="ComplianceReport">
        <div className="section">
          <h2 className="report-title">Compliance Report for January 2025</h2>

          <div className="table-wrapper">
            <div className="table-header">
              <div className="serial-header">S.No.</div>
              <div className="action-header">Grievances and actions taken</div>
              <div className="count-header">Number</div>
            </div>

            {reportRows.map((row, index) => {
              const isTitleRow = row.count === "";

              return (
                <div
                  key={index}
                  className={`table-row ${isTitleRow ? "table-title" : ""}`}
                  style={
                    row.srNo === "7" || row.srNo === "6"
                      ? {
                          background: "#2d2d2d",
                          color: "#fff",
                          textAlign: "center",
                        }
                      : {}
                  }
                >
                  <div className="serialNo">{row.srNo || "\u00A0"}</div>
                  <div className="category">{row.category}</div>
                  <div className="count">
                    {row.count || (isTitleRow ? "\u00A0" : "00")}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </>
  );
}
